import React, { useState, useEffect } from 'react';
import { FileText, X, Plus, Search } from 'lucide-react';
import { API } from '../App';

export function ContextAttacher({ selectedIds, onChange }) {
  const [contexts, setContexts] = useState([]);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    API.get('/api/contexts').then(r => setContexts(r.data.contexts || [])).catch(() => {});
  }, []);

  const filtered = contexts.filter(c =>
    !search || c.title?.toLowerCase().includes(search.toLowerCase())
  );

  const selected = contexts.filter(c => selectedIds.includes(c.id));

  return (
    <div className="mb-6" data-testid="context-attacher">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-semibold font-['Barlow_Condensed']">Attached Context</h3>
        <button onClick={() => setOpen(!open)} className="text-xs text-[#FF4D00] flex items-center gap-1">
          <Plus className="w-3 h-3" /> Attach
        </button>
      </div>

      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-2">
          {selected.map(c => (
            <span key={c.id} className="text-[10px] px-2 py-1 bg-[#1A1A1A] border border-[#FF4D00]/20 text-[#FF4D00] flex items-center gap-1">
              <FileText className="w-3 h-3" />
              {c.title?.slice(0, 30)}
              <button onClick={() => onChange(selectedIds.filter(id => id !== c.id))} className="text-[#A0A0A0] hover:text-[#EF4444]">
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </div>
      )}

      {selected.length === 0 && !open && (
        <p className="text-xs text-[#A0A0A0]">No context attached. Research, docs, or code files from your Context Repository can strengthen the debate.</p>
      )}

      {open && (
        <div className="p-3 bg-[#1A1A1A] border border-[#2A2A2A] mt-2">
          <div className="relative mb-2">
            <Search className="w-3 h-3 text-[#A0A0A0] absolute left-2 top-1/2 -translate-y-1/2" />
            <input type="text" value={search} onChange={e => setSearch(e.target.value)}
              className="w-full pl-7 pr-3 py-1 bg-[#0F0F0F] border border-[#2A2A2A] text-[10px] focus:outline-none focus:border-[#FF4D00]"
              placeholder="Search contexts..." autoFocus />
          </div>
          <div className="max-h-32 overflow-y-auto space-y-0.5">
            {filtered.map(c => {
              const isSelected = selectedIds.includes(c.id);
              return (
                <button key={c.id} onClick={() => {
                  onChange(isSelected ? selectedIds.filter(id => id !== c.id) : [...selectedIds, c.id]);
                }} className={`w-full flex items-center gap-2 px-2 py-1.5 text-left text-[10px] ${isSelected ? 'bg-[#FF4D00]/10' : 'hover:bg-[#2A2A2A]/50'}`}>
                  <span className={`w-3 h-3 border flex items-center justify-center ${isSelected ? 'bg-[#FF4D00] border-[#FF4D00]' : 'border-[#2A2A2A]'}`}>
                    {isSelected && <span className="text-black text-[8px]">✓</span>}
                  </span>
                  <span className="truncate">{c.title}</span>
                  <span className="text-[#A0A0A0] ml-auto shrink-0">{c.type}</span>
                </button>
              );
            })}
          </div>
          <button onClick={() => setOpen(false)} className="text-[9px] text-[#A0A0A0] mt-2">Done</button>
        </div>
      )}
    </div>
  );
}
